import { ServiceData } from '@/types';

import articles from './YOGA_ARTICLES_FI.json';
import exercises from './YOGA_EXERCISES_FI.json';
import recipes from './YOGA_RECIPES_FI.json';

export const YOGA_DATA_FI: ServiceData = {
  articles,
  exercises,
  recipes,
};
